import React, { useState } from 'react';
import { FileDown, X } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from 'react-i18next';

const FloatingFormWidget = () => {
  const { isDark } = useTheme();
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSeh6s1tKOjr7cuCyHglWtuJmazGIbxDADd_cdYwVmuUqEyLSQ/viewform';

  return (
    <div className="fixed bottom-16 sm:bottom-6 left-4 sm:left-6 z-50">
      {/* Expanded Panel */}
      {isExpanded && (
        <div 
          className="mb-3 p-4 rounded-xl shadow-2xl animate-in slide-in-from-bottom-2 duration-300"
          style={{
            backgroundColor: isDark ? '#1a1a1a' : '#ffffff',
            border: `2px solid ${isDark ? '#ff00ff' : '#ff1493'}`,
            boxShadow: isDark 
              ? '0 0 30px rgba(255, 0, 255, 0.4)' 
              : '0 0 25px rgba(255, 20, 147, 0.3)',
            minWidth: '220px'
          }}
        >
          <button
            onClick={() => setIsExpanded(false)}
            className="absolute top-2 right-2 p-1 rounded-full transition-all duration-300 hover:scale-110"
            style={{
              backgroundColor: isDark ? 'rgba(255, 0, 255, 0.2)' : 'rgba(255, 20, 147, 0.1)',
              color: isDark ? '#ff00ff' : '#ff1493'
            }}
          >
            <X className="w-4 h-4" />
          </button>
          
          <h3 
            className="font-bold text-lg mb-2 pr-6"
            style={{ color: isDark ? '#ffffff' : '#0f172a' }}
          >
            {t('widgets.helpfulQuestionnaire')}
          </h3>
          <p 
            className="text-sm mb-3"
            style={{ color: isDark ? '#a0a0a0' : '#64748b' }}
          >
            {t('widgets.questionnaireDesc')}
          </p>
          <a
            href={formUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center py-2 px-4 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
            style={{
              background: isDark 
                ? 'linear-gradient(135deg, #ff00ff 0%, #00ffff 100%)'
                : 'linear-gradient(135deg, #ff1493 0%, #00bfff 100%)',
              color: '#ffffff',
              boxShadow: isDark 
                ? '0 4px 20px rgba(255, 0, 255, 0.4)' 
                : '0 4px 15px rgba(255, 20, 147, 0.3)'
            }}
          >
            {t('widgets.openForm')}
          </a>
        </div>
      )}

      {/* Label above button */}
      <div 
        className="text-center mb-2 animate-bounce"
        style={{
          color: isDark ? '#00ffff' : '#ff1493',
          textShadow: isDark 
            ? '0 0 10px rgba(0, 255, 255, 0.6)' 
            : '0 0 8px rgba(255, 20, 147, 0.4)'
        }}
      >
        <span className="text-xs font-medium">{t('widgets.unsure')}</span>
        <br />
        <span className="text-[10px] font-bold tracking-wider">{t('widgets.followMe')}</span>
      </div>

      {/* Floating Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-110 shadow-lg"
        style={{
          background: isDark 
            ? 'linear-gradient(135deg, #ff00ff 0%, #00ffff 100%)'
            : 'linear-gradient(135deg, #ff1493 0%, #00bfff 100%)',
          color: '#ffffff',
          boxShadow: isDark 
            ? '0 4px 20px rgba(255, 0, 255, 0.5)' 
            : '0 4px 18px rgba(255, 20, 147, 0.4)'
        }}
      >
        <FileDown className="w-4 h-4" />
        <span className="hidden sm:inline text-xs">{t('widgets.helpfulQuestionnaire')}</span>
      </button>
    </div>
  );
};

export default FloatingFormWidget;
